module.exports = __webpack_public_path__ + "static/media/step1.5c7af1b7.svg";